/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PartialUpdateAutomationMutationRequest,
  PartialUpdateAutomationMutationResponse,
  PartialUpdateAutomationPathParams,
  PartialUpdateAutomation400,
} from '../types/PartialUpdateAutomation'

function getPartialUpdateAutomationUrl({
  id,
}: {
  id: PartialUpdateAutomationPathParams['id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/automations/automations/${id}/` as const,
  }
  return res
}

/**
 * @description Override partial_update to handle both regular JSON and multipart form data
 * @summary Partially update an automation
 * {@link /api/v1/automations/automations/:id/}
 */
export async function partialUpdateAutomation(
  { id }: { id: PartialUpdateAutomationPathParams['id'] },
  data?: PartialUpdateAutomationMutationRequest,
  config: Partial<RequestConfig<PartialUpdateAutomationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    PartialUpdateAutomationMutationResponse,
    ResponseErrorConfig<PartialUpdateAutomation400>,
    PartialUpdateAutomationMutationRequest
  >({
    method: 'PATCH',
    url: getPartialUpdateAutomationUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
